import { render, staticRenderFns } from "./modalNotificacionSeguro.vue?vue&type=template&id=3b2e30e8&"
import script from "./modalNotificacionSeguro.vue?vue&type=script&lang=js&"
export * from "./modalNotificacionSeguro.vue?vue&type=script&lang=js&"
import style0 from "./modalNotificacionSeguro.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports